export default "__VITE_ASSET__B9anblf8__"